require('../../vendor/statikbe/laravel-cookie-consent/resources/js/cookie-consent.js');

import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";

// only launch in production, we don't want to waste your quota while you're developing.
if (process.env.NODE_ENV === "production") {
    flare.light('OKtf3pWqaKutCSBB16RkxH7T7DpRQE9K');
}

require('./bootstrap');
//require('./global/dropdowns.js');
require('./global/extend.js');
require('./global/debounce.js');
require('./global/alerts.js');
require('./global/carousels.js');

//import bannerController from "./global/bannercontrol";
import scrollController from "./global/scrollmanager";
import WaveAnimation from "./global/wave";

import store from "./store";
import vuex from "vuex";
Vue.use(vuex);

Vue.use(flareVue);

// Used commonly. Plain JS BS included.
require('../../node_modules/bootstrap/js/dist/collapse.js');
require('../../node_modules/bootstrap/js/dist/dropdown.js');
require('../../node_modules/bootstrap/js/dist/modal.js');

Vue.component('product-pricing', require('./app/components/ProductPricing').default);
Vue.component('product-card', require('./app/components/ProductCard').default);
Vue.component('product-list', require('./app/components/ProductList').default);
Vue.component('product-basket-count-flag', require('./app/components/ProductBasketCountFlag').default);
Vue.component('promoted-products', require('./app/components/PromotedProducts').default);
Vue.component('category-title', require('./app/components/partials/CategoryTitle.vue').default);
Vue.component('manage-abandoned-orders', require('./rep/components/ManageAbandonedOrders.vue').default);
Vue.component('email-submission', require('./app/components/partials/EmailSubmission.vue').default);

Vue.filter('currencyDecimals', function (value) {
    return parseFloat(value).toFixed(2);
});

Vue.filter('roundPrice', function (value) {
    const parsed = parseFloat(value)
    return Number(parsed.toFixed(2));
});

Vue.filter('formatDate', function (value) {
    if (value) {
        const dateObj = new Date(value);

        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth()+1).toString().padStart(2, '0');
        const date = dateObj.getDate().toString().padStart(2, '0');

        // check for USA locale
        const locale =  window.location.host.split(".")[0];
        if(locale == 'us') {
            return `${month}/${date}/${year}`;
        }

        return `${date}/${month}/${year}`;
    } else {
        return '';
    }

});


Vue.mixin(require('./global/trans'))

const app = new Vue({
    store,
    el: '#app',
});

/*************** MOBILE MENU ********************/
var mobilemenu = function () {

    //Menu Toggle
    var mobiletoggle = document.getElementById('mobile-menu-toggle');
    var mobilemenu = document.getElementById('mob-nav');
    mobiletoggle.onclick = function (e) {
        e.target.classList.toggle('open');
        mobilemenu.classList.toggle('open');
        document.body.classList.toggle('modal-open');
    };

    //Mobile Submenu
    var hassubmenu = document.querySelectorAll("#mobile-menu .has-megamenu > a ");
    for (var i = 0; i < hassubmenu.length; i++) {
        hassubmenu[i].onclick = function (e) {
        e.preventDefault();

        var el = e.target;
        var showmenu = el.nextElementSibling;
        if (showmenu) {
            //el.classList.toggle('open');
            showmenu.classList.toggle('open');
        }

        };
    }

    //Mobile Submenu Close
    var backbuttons = document.querySelectorAll(".submenu-actions__back");
    for (var i = 0; i < backbuttons.length; i++) {
        backbuttons[i].onclick = function (e) {
        e.preventDefault();
        var megamanus = document.querySelectorAll(".mega-nav.open");
        for (var x = 0; x < megamanus.length; x++) {
            megamanus[x].classList.remove('open');
        }

        };
    }

    //Submenu Accordions
    var submenutitles = document.querySelectorAll('.mega-nav__title');
    for (var i = 0; i < submenutitles.length; i++) {
        submenutitles[i].onclick = function (e) {
        var el = e.target;
        el.classList.toggle('open');
        el.nextElementSibling.classList.toggle('open');
        }
    }
};

const el = document.querySelector(".header")
const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  { threshold: [1] }
);
const bodyHasClass = document.body.classList.contains('home-page');

if (bodyHasClass) {
    observer.observe(el);
}

//Banner Control
// function bannerControl() {
//     const bannerControlled = document.querySelectorAll('.banner-control');
//     bannerControlled.forEach(el => {
//         const bannerControl = new bannerController(el);
//     });
// }

//Scroll Control
// function scrollControl() {
//     const scrollcontrolled = document.querySelectorAll('.scroll-control');
//     scrollcontrolled.forEach(el => {
//         const scrollcontrol = new scrollController(el);
//     });
// }

const init = function () {
    mobilemenu();
    //bannerControl();
    //scrollControl();
};

var loading = true;

window.onload = function () {
  if (loading) {
    init();
    loading = false;
  }
};

let elements = document.querySelectorAll('.toggle-button');

elements.forEach(i => {
  i.addEventListener('click', function(e) {

    var targetBox = e.target.dataset.slideoutid;

    if(e.target.classList.contains('opened')) {
        e.target.classList.remove('opened');
        document.querySelector("#" + targetBox).classList.remove("opened");
    } else {
        e.target.classList.add('opened');
        document.querySelector("#" + targetBox).classList.add("opened");
    }

  });
});

window.openVideo = function (media) {

    document.querySelector('#mediaIframe').innerHTML = media.framePath;

}

// Footer Popular Search Toggle
var popularSearchesToggle = document.querySelector('#popularSearchesToggle');
if(popularSearchesToggle) {
        popularSearchesToggle.addEventListener('click', function(e) {
        var popularNav = document.querySelector('#popularSearches');


        if (popularNav.classList.contains('d-none')) {
            popularNav.classList.remove('d-none');
            popularNav.classList.add('d-block');
            this.innerHTML = '<a>Hide Popular Searches</a>';
        } else {
            popularNav.classList.remove('d-block');
            popularNav.classList.add('d-none');
            this.innerHTML = '<a>Popular Searches</a>';
        }
    })
}

// Category SEO Text toggles
var categorySeoTextToggle = document.querySelector('#seo_text_toggle');
if(categorySeoTextToggle) {
    categorySeoTextToggle.addEventListener('click', function(e) {
        var SeoContent = document.querySelector('#seo_text');
        var readLessClicked = new CustomEvent('read-less-clicked');

        if (SeoContent.classList.contains('d-block')) {
            document.dispatchEvent(readLessClicked);
        }
    })
}

// Apply Page Address fields
// when inputs that have data-address-type of 'billing', get the data-address-value of the field and apply it to the field that has the same data-address-value but data-address-type of 'shipping'
var addressFields = document.querySelectorAll('[data-address-type]');
var sameAsBilling = document.querySelector('#same_as_billing');
if(addressFields) {
    addressFields.forEach(function(field) {
        field.addEventListener('change', function(e) {

            var addressType = e.target.dataset.addressType;
            var addressValue = e.target.dataset.addressValue;
            var addressField = document.querySelector('[data-address-type="shipping"][data-address-value="' + addressValue + '"]');

            if(addressField && sameAsBilling.checked) {
                addressField.value = e.target.value;
            }
        })
    })
}

if(sameAsBilling && sameAsBilling.checked) {
    var shippingFields = document.querySelectorAll('[data-address-type="shipping"]');
    shippingFields.forEach(function(field) {
        field.setAttribute('readonly', 'readonly');
    });
}

if(sameAsBilling) {
    sameAsBilling.addEventListener('change', function(e) {
        var shippingFields = document.querySelectorAll('[data-address-type="shipping"]');
        if(e.target.checked) {
            shippingFields.forEach(function(field) {
                field.setAttribute('readonly', 'readonly');
                var billingField = document.querySelector('[data-address-type="billing"][data-address-value="' + field.dataset.addressValue + '"]');
                field.value = billingField.value;
            });
        } else {
            shippingFields.forEach(function(field) {
                field.removeAttribute('readonly');
            });
        }
    })
}

//Wave Blocks
const waveblocks = document.querySelectorAll('.waves');
waveblocks.forEach(el => {
    console.log(el.id);
    const waveAnimation = new WaveAnimation(el.id);
});

//Back to top
document.addEventListener('DOMContentLoaded', function() {
    var backToTop = document.getElementById('back-to-top');

    if (backToTop !== null && backToTop !== undefined) {
        backToTop.addEventListener('click', function() {
            backToTop.classList.add('active');

            setTimeout(function() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 500);

            setTimeout(function() {
                backToTop.classList.remove('active');
            }, 2000);
        });
    }
});

document.querySelectorAll('.cta-carousel__item').forEach(item => {
    item.addEventListener('mouseenter', () => {
        let animation = item.querySelector('animate');
        if (animation) {
            animation.beginElement();
        }
    });

    item.addEventListener('mouseleave', () => {
        let animation = item.querySelector('animate');
        if (animation) {
            animation.endElement();
        }
    });
});

// Add negative margin to footer if newsletter-footer is present
document.addEventListener('DOMContentLoaded', function() {
    var newsletterFooter = document.getElementById('newsletter-footer');
    var footer = document.getElementById('site-footer');

    if (newsletterFooter !== null && newsletterFooter !== undefined) {
        footer.style.marginTop = '-70px';
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Enable hover for the dropdown
    var accountDropdown = document.getElementById('accountDropdown');

    if(accountDropdown) {
        accountDropdown.addEventListener('click', function () {
              window.location.href = '/account';
        });

        accountDropdown.addEventListener('mouseover', function () {
            document.querySelector('div[aria-labelledby="accountDropdown"]').setAttribute('aria-expanded', 'true');
            document.querySelector('div[aria-labelledby="accountDropdown"]').classList.add('show');
        });

        accountDropdown.addEventListener('mouseout', function () {
            document.querySelector('div[aria-labelledby="accountDropdown"]').setAttribute('aria-expanded', 'false');
            document.querySelector('div[aria-labelledby="accountDropdown"]').classList.remove('show');
        });
    }
});

